const TICKET_TOKEN = /^[0-9a-f]{8}-[0-9a-f]{4}-5[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** A deposit or payout token: a version-5 UUID, the same check the backend applies. */
export const isTicketToken = (value: string): boolean => TICKET_TOKEN.test(value)
